import React, { useEffect, useState } from "react";
import { getAllActive, getById } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";

function ProviderUserRoleAttachPage(props) {
    const [users, setUsers] = useState(null);
    const [roles, setRoles] = useState(null);
    const [provider, setProvider] = useState(null);
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        const search = window.location.search;
        const params = new URLSearchParams(search);
        const providerId = params.get("entityId");

        getById("provider/read", providerId, token).then((data) => {
            if (data === null) {
                toast.error("Failed to load provider");
            } else {
                setProvider(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("user/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load users");
            } else {
                setUsers(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("role/read", token, true).then((data) => {
            if (data === null) {
                toast.error("Failed to load roles");
            } else {
                setRoles(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });
    }, []);

    useEffect(() => {
        if (provider && users && roles) {
            setColumns([
                {
                    inputType: inputType.SELECT,
                    labelText: "provider",
                    required: true,
                    disabled: true,
                    inputId: "provider_id",
                    validationFunction: () => {return null;},
                    selectOptions: formatArrayForSelectInput([provider], "name")
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "User",
                    required: true,
                    inputId: "user_id",
                    selectOptions: formatArrayForSelectInput(users, "email"),
                    validationFunction: () => {return null}
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "Role",
                    required: true,
                    inputId: "role_id",
                    selectOptions: formatArrayForSelectInput(roles, "name"),
                    validationFunction: () => {return null}
                }
            ])
        }
    }, [provider, users, roles])

    return (
        <GenericInsertUpdatePage inputs={columns}
            setLoggedIn={props.setLoggedIn}
            endpoint={"provider-user-role/create"}
            pageTitle={"Attach Provider User Role"}
            isUpdate={false} />
    )
}

export default ProviderUserRoleAttachPage;